import { render, staticRenderFns } from "./Boomke.vue?vue&type=template&id=63cf269c&"
import script from "./Boomke.vue?vue&type=script&lang=ts&"
export * from "./Boomke.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports